import { render } from "./AddEducationalUnitByFile.vue?vue&type=template&id=341e4466&scoped=true"
import script from "./AddEducationalUnitByFile.vue?vue&type=script&lang=js"
export * from "./AddEducationalUnitByFile.vue?vue&type=script&lang=js"

import "./AddEducationalUnitByFile.vue?vue&type=style&index=0&id=341e4466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341e4466"]])

export default __exports__